import { CHART_COLORS, isColorUsed } from '../../utils/colorPalette';
import s from './ColorPicker.module.scss';

const ColorPicker = ({ value, onChange, usedColors = [] }) => {
    return (
        <div className={s.Root}>
            <div className={s.Grid}>
                {CHART_COLORS.map((color) => {
                    const isSelected =
                        value?.toUpperCase() === color.toUpperCase();
                    const isUsed =
                        isColorUsed(color, usedColors) && !isSelected;

                    return (
                        <button
                            key={color}
                            type="button"
                            className={`${s.Swatch} ${isSelected ? s.Selected : ''} ${isUsed ? s.Used : ''}`}
                            style={{ backgroundColor: color }}
                            onClick={() => onChange(color)}
                            title={isUsed ? `${color} (in use)` : color}>
                            {isSelected && (
                                <span className={s.Checkmark}>
                                    <svg
                                        width="10"
                                        height="10"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="4">
                                        <path d="M20 6L9 17l-5-5" />
                                    </svg>
                                </span>
                            )}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default ColorPicker;
